/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { CpdsGridProps, CpdsGridStyleProps } from '../typings'
import { mapPropsToCss } from '../../utils/mapPropsToCss';

export const CpdsGridStylePropsMapper = {
  padding: 'padding',
  gap: 'gap',
  columnGap: 'column-gap',
  rowGap: 'row-gap',
  gridTemplateColumns: 'grid-template-columns',
  width: 'width',
  maxWidth: 'max-width',
  margin: 'margin',
  justifyContent: 'justify-content',
  overFlow: 'overflow',
  overFlowX: 'overflow-x',
  overFlowY: 'overflow-y',
  gridAutoColumns: 'grid-auto-columns',
  gridAutoRows: 'grid-auto-rows',
  gridAutoFlow: 'grid-auto-flow',
  backGround: 'background',
  textAlign: 'text-align',
  minHeight: 'min-height',
  alignItems: 'align-items',
  gridTemplateAreas: 'grid-template-areas',
  backGroundColor: 'background-color',
  gridColumn: 'grid-column',
  display: 'display'
}

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} */
// const CpdsGridStyleTag = styled.div`
//   ${({ theme: { styles : {cpds} } }) => css`
//     background-color: blue;
//     ${(props) => props?.styleOverrides || ''}
//   `}
// `;
// const mapPropsToCss = (props: CpdsGridStyleProps) => {
//   return Object.entries(CpdsGridStylePropsMapper)
//     .map(([key, cssProp]) => {
//       if (props[key as keyof CpdsGridStyleProps]) {
//         return `${cssProp}: ${props[key as keyof CpdsGridStyleProps]};`;
//       }
//       return '';
//     })
//     .join(' ');
// };

const CpdsGridStyleTag = styled.div`   
  ${({ theme, ...props }) => {     
  // const dynamicStyles = props.gridStyleProps ? mapPropsToCss(props.gridStyleProps) : '';
  const dynamicStyles = props.gridStyleProps ? mapPropsToCss(props.gridStyleProps, CpdsGridStylePropsMapper, props.gridStyleProps.mediaQueries) : '';
  const { cpds } = theme.styles || {};  
  return css`
    display: grid; 
    ${dynamicStyles}
    ${props?.styleOverrides || ''} `; }}
  `;

  // const CpdsGridStyleTag = styled.div`   
  // ${({ theme, ...props }) => {     
  // // const dynamicStyles = props.gridStyleProps ? mapPropsToCss(props.gridStyleProps) : '';
  // const dynamicStyles = props.gridStyleProps ? mapPropsToCss(props.gridStyleProps, CpdsGridStylePropsMapper, props.gridStyleProps.mediaQueries) : '';
  // const { cpds } = theme.styles || {};  
  // return css`
  //   background-color: blue; 
  //   display: grid; 
  //   max-width: 100%;
  //   grid-template-columns: auto auto auto;
  //   padding: ${cpds?.spaces?.space_56};
  //   gap: ${cpds?.spaces?.space_56};
  //   ${dynamicStyles}
  //   ${props?.styleOverrides || ''} `; }}
  // `;

export { CpdsGridStyleTag };
